import { useMemo } from "react";
import { useGetQualificationStandardsQuery } from "../api/qualificationStandard";

export const useGetQualificationStandardIdByCode = (
    code: string,
): number | null => {
    const { data: qualificationStandardData } =
        useGetQualificationStandardsQuery({ items_per_page: 9999 });

    const found = useMemo(() => {
        if (!qualificationStandardData?.data) {
            return null;
        }
        return qualificationStandardData.data.find((s) => s.code === code);
    }, [qualificationStandardData?.data, code]);

    return found ? found.id : null;
};
